<div class="card" *ngFor="let item of value;let i=index" style="background-color: rgba(100, 100, 100, 0.1);">
  <div class="tw-flex">
    <p-button icon="pi pi-trash" (click)="removeItem(i)" label="Remove this item"></p-button>
  </div>
  <div class="p-fluid p-formgrid grid">
    <div class="field col-12">
      <label htmlFor="condition">Just One Of These Conditions</label>
      <ng-container *ngFor="let condition of item.Conditions;let i=index">
        <div *ngIf="i">OR</div>
        <div class="card">
          <div class="tw-flex">
            <p-button icon="pi pi-trash" (click)="item.Conditions.splice(i,1)" label="Remove this OR"></p-button>
          </div>
          <brt-menu-condition [(ngModel)]="item.Conditions[i]"></brt-menu-condition>
        </div>
      </ng-container>
      <div class="tw-flex">
        <p-button label="OR" icon="pi pi-plus" (click)="item.Conditions.push({})"></p-button>
      </div>
    </div>

    <!-- <div class="field col-12">
      <label htmlFor="price">Item Price</label>
      <brt-promotion-price [(ngModel)]="item.Price"></brt-promotion-price>
    </div> -->

  </div>
</div>
<div class="tw-flex">
  <p-button label="Add new item" icon="pi pi-plus" (click)="addItem()"></p-button>
</div>